// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MuiPickersDay-root{margin-right:0 !important;margin-left:0 !important}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA,oBACC,yBAAA,CACA,wBAAA","sourcesContent":[".MuiPickersDay-root {\n\tmargin-right: 0 !important;\n\tmargin-left: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
